import React from 'react';
import { Icon } from 'semantic-ui-react';
import {
  HomeLine,
  BarChartSquare02,
  Users03,
  CoinsStacked02,
  Repeat04,
  Ticket01,
  Award01,
  User02,
  LifeBuoy01,
  Settings01,
  Settings02,
  Heart,
  CreditCard01,
  Building01,
  ClockStopwatch,
  ChevronRight,
  UserCircle,
  Download01,
  Code02,
  LogOut01,
  TrendUp01,
  SwitchHorizontal01,
  ShieldTick,
} from '@untitledui/icons';

interface CustomIconProps {
  name: string;
  className?: string;
  size?: string | number;
  color?: string;
  style?: React.CSSProperties;
}

// Map kebab-case names to @untitledui/icons components
const iconMap: { [key: string]: React.FC<any> } = {
  'home-01': HomeLine,
  'bar-chart-square-02': BarChartSquare02,
  'users-03': Users03,
  'coins-stacked-01': CoinsStacked02,
  'repeat-04': Repeat04,
  'ticket-01': Ticket01,
  'award-01': Award01,
  'user-02': User02,
  'life-buoy-01': LifeBuoy01,
  'settings-01': Settings01,
  'settings-02': Settings02,
  'heart-01': Heart,
  'credit-card-01': CreditCard01,
  'building-01': Building01,
  'clock-stop-watch-01': ClockStopwatch,
  'chevron-right-01': ChevronRight,
  'user-circle-01': UserCircle,
  'download-01': Download01,
  'code-01': Code02,
  'logout-01': LogOut01,
  'dashboard-01': TrendUp01,
  'switch-horizontal-01': SwitchHorizontal01,
  'shield-tick': ShieldTick,
};

const CustomIcon: React.FC<CustomIconProps> = ({
  name,
  className = '',
  size = 20,
  color = 'currentColor',
  style = {},
  ...props
}) => {
  // Check if it's a mapped @untitledui/icons icon
  const UntitledIcon = iconMap[name];
  if (UntitledIcon) {
    return (
      <UntitledIcon
        size={typeof size === 'string' ? parseInt(size, 10) : size}
        color={color}
        className={`custom-icon ${className || ''}`}
        style={style}
        {...props}
      />
    );
  }

  // Fallback to Semantic UI Icon
  return (
    <Icon
      name={name as any}
      className={className}
      style={{
        color,
        fontSize: typeof size === 'number' ? `${size}px` : size,
        ...style,
      }}
      {...props}
    />
  );
};

export default CustomIcon;
